// "Identify Places" (Places menu, 4.10.55, 2026-10-28): name the places
// already in the guide from their location — like Personalize Guide with
// Photos' review, but the photos are the places' own and there is no
// grouping. These helpers pick and order the places, collect each place's
// photos and apply the chosen names. Kept identical in andiamo-web and
// andiamo-places (src/Common).
import { isFileLikeName } from "./placeNaming";
import { renameLinkedEvents } from "./placeRename";

export const hasLocation = (p) => {
  const lat = parseFloat(p?.Lat);
  const lng = parseFloat(p?.Longi);
  return Number.isFinite(lat) && Number.isFinite(lng) && !(lat === 0 && lng === 0);
};

// Visible places with a location; those still named after a photo file
// first (they are why this exists), then the rest in guide order.
export function placesToIdentify(guide) {
  const list = (guide?.places?.placesList || []).filter((p) => !p.Hidden && hasLocation(p));
  return [...list.filter((p) => isFileLikeName(p.Name)), ...list.filter((p) => !isFileLikeName(p.Name))];
}

// The place's cover photo, then pictures in its notes; no repeats, at most max.
export function placePhotos(place, max = 6) {
  const out = [];
  const add = (u) => {
    const url = String(u || "").trim();
    if (url && !out.includes(url)) out.push(url);
  };
  add(place?.Photo_m || place?.Photo);
  const re = /<img[^>]*\ssrc=["']([^"']+)["']/gi;
  let m;
  while ((m = re.exec(String(place?.Info || ""))) && out.length < max) add(m[1]);
  return out.slice(0, max);
}

// renames: [{ id, newName }]. Renames the places and their events whose
// title is exactly the old name (same rule as the place editor). Returns
// [{ oldName, newName, renamedEvents }] for the ones that changed.
export function applyPlaceRenames(guide, renames) {
  const done = [];
  (renames || []).forEach(({ id, newName }) => {
    const p = (guide?.places?.placesList || []).find((x) => String(x.ID) === String(id));
    const to = String(newName || "").trim();
    if (!p || !to || to === String(p.Name || "").trim()) return;
    const oldName = String(p.Name || "").trim();
    p.Name = to;
    const renamedEvents = renameLinkedEvents(guide?.schedule?.events, p.ID, oldName, to);
    done.push({ oldName, newName: to, renamedEvents });
  });
  return done;
}

// A deleted place's events (2026-10-28, Personalize "Delete this place"): an
// event for only that place is removed; one that also lists other places
// keeps them and just drops this one. Changes schedule.events in place;
// returns { removed, edited }.
export function removePlaceFromEvents(schedule, placeId) {
  const id = String(placeId);
  let removed = 0;
  let edited = 0;
  const events = schedule?.events || [];
  for (let i = events.length - 1; i >= 0; i--) {
    const ids = String(events[i].Places || "").split(",").map((s) => s.trim()).filter(Boolean);
    if (!ids.includes(id)) continue;
    const rest = ids.filter((x) => x !== id);
    if (rest.length === 0) {
      events.splice(i, 1);
      removed++;
    } else {
      events[i].Places = rest.join(",");
      edited++;
    }
  }
  return { removed, edited };
}
